// @flow
import React, { Component } from 'react';

import type { LandingThemeType } from '@site-builder/common/src/types/model/landing';
import type { FiveSymbolLocale } from '@site-builder/common/src/utils/locale';

import ARROW_ICON from '../../../assets/images/icons/arrow.svg';
import { addScriptData } from '../../../reducers/modules/site-builder/scripts';
import { getBlackOrWhite } from '../../../utils/colors';
import { validateEmail } from '../../../utils/validations';
import { States } from '../../settings/Input';
import { EditorText } from '../EditorText';

import './style.pcss';

type Props = {|
  callToAction: Object,
  landingTheme: LandingThemeType,
  isServerSideRender: boolean,
  placeholder: string,
  loginId: string,
  blockId: string,
  blockType: string,
  locale: FiveSymbolLocale,
  onCheckoutBlock: () => void,
  onBlur: () => void,
  isDescriptionEnable: boolean,
  addScriptData: typeof addScriptData
|};

type State = {|
  inputState: string
|}

class Subscription extends Component<Props, State> {
  state: State = {
    inputState: States.DEFAULT_STATE
  };

  subscriptionRef: ?HTMLInputElement;

  changeText = () => {
    const email = this.subscriptionRef && this.subscriptionRef.value;
    this.setState({
      inputState: email && validateEmail(email) ? States.SUCCESS_STATE : States.DEFAULT_STATE
    });
  };

  setTextInputRef = (element: ?HTMLInputElement) => {
    this.subscriptionRef = element;
  };


  render() {
    const {
      landingTheme,
      placeholder,
      isServerSideRender,
      addScriptData,
      loginId,
      blockId,
      blockType,
      callToAction,
      locale,
      onCheckoutBlock,
      onBlur,
      isDescriptionEnable
    } = this.props;
    const { accentColor, textColor } = landingTheme;
    const { values, _id } = callToAction;
    const { inputState } = this.state;

    let elementId = `subscribe-${blockId}`;
    if (blockType === 'promoSlider') {
      elementId += `-${_id}`;
    }
    const arrowHoveredColor = getBlackOrWhite(accentColor);

    if (isServerSideRender && addScriptData) {
      addScriptData('subscriptions', {
        loginId, elementId, textColor, arrowHoveredColor, accentColor
      });
    }

    return (
      <form id={elementId} className={`ui-site-subscription ui-site-subscription${inputState}`}>
        {isDescriptionEnable && (
          <EditorText
            size='medium'
            values={values}
            text={values.text[locale]}
            locale={locale}
            field='text'
            isServerSideRender={isServerSideRender}
            onCheckoutBlock={onCheckoutBlock}
            onBlur={onBlur}
          />
        )}
        <div className='ui-site-subscription__input-wrapper'>
          <input
            className='ui-site-subscription__input swiper-no-swiping'
            ref={this.setTextInputRef}
            name='email'
            placeholder={placeholder}
            onChange={this.changeText}
          />
          <button
            className='ui-site-subscription__button'
            aria-label='subscribe'
            type='submit'
            data-xa-extra={JSON.stringify({ loginId, block: blockType })}
          >
            <div
              className='ui-site-subscription__status-icon'
              dangerouslySetInnerHTML={{ __html: ARROW_ICON }} // eslint-disable-line
            />
            <div
              className='ui-site-subscription__status-preloader'
            />
          </button>
        </div>
      </form>
    );
  }
}

export default Subscription;
